import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=24680902"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports